<template>
<div id="estados_ws">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Administrar Estados de Pedimento" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>
            <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;">
              <v-card>
                <v-card-title>
                  <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">
                      {{ update ? "edit" : "add" }}
                    </v-icon>&nbsp;
                    <span class="subheading">
                      <strong>{{ update ? "Actualizar" : "Nuevo" }} Estado de Pedimento</strong>
                    </span>
                  </v-card>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.native="modal = false" class="close_modal">
                    <v-icon class="white--text">cancel</v-icon>
                  </v-btn>
                </v-card-title>
                <v-form ref="form" lazy-validation>
                  <v-card-text>
                    <v-container grid-list-md text-xs-center @keyup.enter="guardar()">
                      <v-layout row wrap>
                        <v-flex s12 m12 l12>
                          <v-text-field name="equivalencia" label="Equivalencia" type="text" v-model="model.equivalencia" :rules="[rules.required]" maxlength="50"></v-text-field>
                        </v-flex>
                        <v-flex s12 m12 l12>
                          <v-text-field name="clave" label="Clave" type="text" v-model="model.clave" :rules="[rules.required]" maxlength="50"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex s12 m12 l12>
                          <v-autocomplete v-model="model.descripciones" :items="model.descripciones" :hide-no-data="true" :hide-selected="true" multiple chips small-chips deletable-chips label="Descripciones" :append-outer-icon="'mdi-plus'"
                            :rules="[requiredArray]" @click:append-outer="modalDescripcion=true; descripcion_nueva='';">
                          </v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click.native="modal = false">
                    <v-icon>cancel</v-icon>Cancelar
                  </v-btn>
                  <v-btn color="success" :loading="loading" @click.native="guardar()">
                    <v-icon>done</v-icon>
                    {{ update ? "Actualizar" : "Guardar" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-actions>

          <v-card-text>
            <div id="datagrid">
              <v-client-table ref="vuetable" :data="datos.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>
                <template slot="descripciones" slot-scope="props">
                  {{props.row.descripciones.join(", ")}}
                </template>
                <template slot="actions" slot-scope="props">
                  <v-speed-dial :id="props.row._id" direction="left" open-on-hover>
                    <template v-slot:activator>
                      <v-btn :id="props.row._id" x-small fab dark color="primary">
                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>

                    <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row._id)" title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="deleteRegistro(props.row._id)" title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
  <v-dialog v-model="modalDescripcion" max-width="30%">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon class="white--text">mdi-file-import</v-icon>&nbsp;
          <span class="subheading">
            <strong>Agregar Descripción</strong>
          </span>
        </v-card>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="modalDescripcion = false" class="close_modal">
          <v-icon class="white--text">cancel</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="form_codigo" lazy-validation>
          <v-container grid-list-md>
            <v-row justify="center">
              <v-col sm="12">
                <v-text-field label="Descripción" v-model="descripcion_nueva" :rules="[rules.required]"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="model.descripciones.push(descripcion_nueva); modalDescripcion=false;">
          <v-icon>cancel</v-icon> Agregar
        </v-btn>
        <v-btn @click.native="modalCodigo = false">
          <v-icon>cancel</v-icon> Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    fab: false,
    name: "datagrid",
    columns: ["clave", "equivalencia", "descripciones", "actions"],
    show_loading: true,
    options: {
      filterable: ["descripciones", "clave", "equivalencia"],
      sortable: ["descripciones", "clave", "equivalencia"],

      headings: {
        equivalencia :"Equivalencia",
        descripciones: "Descripciones",
        clave: "Clave",
        actions: "Operaciones"
      }
    },
    URL: "",
    show_loading: true,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Catálogos",
        disabled: true,
        to: ""
      },
      {
        text: "Estados WS",
        disabled: true,
        to: ""
      }
    ],
    loading: false,
    title: "",
    modal: false,
    modalDescripcion: false,
    descripcion_nueva: "",
    update: false,
    pagination: {
      sortBy: "clave"
    },
    search: "",
    model: {
      descripciones: [],
      clave: "",
      equivalencia:null
    },
    rules: {
      required: v => !!v || "Este campo es requerido"
    },
    datos: {
      selected: [],
      headers: [{
          text: "Descripciones",
          value: "descripciones"
        },
        {
          text: "Clave",
          value: "clave",
        },
        {
          text: "Operaciones",
          value: "operaciones",
          align: "center"
        }
      ],
      items: []
    }
  }),
  computed: {
    datafiltered() {
      if (this.$refs.vuetable != null) {
        return this.$refs.vuetable.allFilteredData;
      } else {
        return this.datos.items;
      }
    }
  },
  methods: {
    requiredArray: function(val) {
      if (val != null && val.length > 0) {
        return true;
      } else
        return "Este campo es requerido";
    },
    openModal: function(type) {
      if (type === 1) {
        this.limpiarModel();
        this.title = "Nuevo Estado de Pedimento";
        this.update = false;
      } else {
        this.title = "Actualizar Estado de Pedimento";
        this.update = true;
      }
      this.modal = true;
    },

    limpiarModel: function() {
      this.model = {
        "clave": "",
        "descripciones": [],
        "equivalencia": null
      }
    },

    guardar() {
      const datos = this.model;

      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        var metodo = "post";
        var urlCliente = this.URL;
        if (this.update == true) {
          metodo = "put";
          urlCliente += this.model._id + "/";
        }
        axios({
            method: metodo,
            url: urlCliente,
            data: datos
          })
          .then(res => {
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Los datos se guardaron correctamente",
              footer: ""
            });
            this.cargar();
            this.modal = false;
          })
          .catch(error => {
            this.$swal({
              position: "center",
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al guardar los datos"
              //showConfirmButton: false,
            });
            console.log(error);
            this.cargar();
            this.modal = false;
          });
      }
    },

    cargar: function() {
      axios
        .get(this.URL)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos.items = res.data;
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {

          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },

    getRegistro: function(id_registro) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios
        .get(this.URL + id_registro + "/")
        .then(response => {
          this.model = response.data;
          this.openModal(2); //ACTUALIZAR
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el registro",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    }, //getRegistro

    deleteRegistro: function(id_registro) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          axios
            .delete(this.URL + id_registro + "/")
            .then(response => {
              this.cargar();
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El registro se eliminó correctamente.",
                //position: 'bottom-end',
                //timer: 3000,
                //showConfirmButton: false,
                footer: ""
              });
            })
            .catch(error => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el registro",
                footer: ""
              });
            }).then(() => {
              this.$root.$dialogLoader.hide();
            });
        }
      });
    }, //delete
  }, //methods
  created: function() {
    this.URL = this.$hostname + "catalogos/estados_ws/";
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.cargar();
  }
};
</script>

<style scoped>
.v-select >>> .v-select__selections{
  text-transform: initial !important;
}
</style>
